export const EREF_NOT_REFERENCED_LABEL = "Times referenced is 0"
export const EREF_NOT_REFERENCED_MESSAGE =
	"Times referenced is 0 — this elevation's objects are not counted in the quotation price."

/**
 * REQ-464: an eref counted zero times drops its objects from the price. Exactly 0 only — a missing
 * value (legacy payloads/fixtures) is not an error.
 */
export const isErefNotReferenced = (timesReferenced: number | null | undefined) => timesReferenced === 0
